import React from "react";
import { CopyRightWrapper } from "./Styled/CopyRight.styled";

const CopyRight = () => {
  return <CopyRightWrapper>Copyright © by eMko</CopyRightWrapper>;
};

export default CopyRight;
